'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLinearScale = function MdLinearScale(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 15.9c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1c-1.7 0-3.2-1-3.8-2.5h-4.9c-0.6 1.5-2.1 2.5-3.8 2.5s-3.2-1-3.8-2.5h-4.9c-0.6 1.5-2.1 2.5-3.8 2.5-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1c1.7 0 3.2 1 3.8 2.5h4.9c0.6-1.5 2.1-2.5 3.8-2.5s3.2 1 3.8 2.5h4.9c0.6-1.5 2.1-2.5 3.8-2.5z' })
        )
    );
};

exports.default = MdLinearScale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/linear-scale.js
// module id = 1673
// module chunks = 168707334958949